<template>
  <div id="login">
      
  </div>
</template>

<script>

export default {
  name: "LoginSignUpSidePage",
  data() {
    return {
      email: null,
    }
  }
};

</script>

<style lang="scss" scoped>
#sign-up {
  width: 100%;
  height: 100%;

  .content {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>